import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentView from "../../myComp/ContentView";

class PriceListList extends PlusComponent {
  constructor(props) {
    super(props, "contentPriceList");         
  }

  render(){     
    return (
        <div>
          <ContentView {...this.props} title="Listini" controller="contentPriceList"></ContentView>
        </div>
      )
    }
}

export default PriceListList;